import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { BsArrowRepeat, BsThreeDotsVertical } from "react-icons/bs";
import { MdFileDownload } from "react-icons/md";

const RefundsSuper = () => {
  return (
    <Wrapper>
      <div className="container py-5">
        <div className="card border-0 shadow-sm p-4">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
            <div>
              <h4 className="text-dark mb-1 d-flex align-items-center">Refund & Cancelation</h4>
              <p className="text-muted mb-0">Manage and process refund and cancellation request</p>
            </div>
            <div className="d-flex gap-3 mt-2 mt-md-0">

              <button className="btn btn-primary d-flex align-items-center">
                <MdFileDownload className="me-2" size={20} />
                Export Request
              </button>
            </div>
          </div>

          <div className="d-flex align-items-center flex-wrap gap-2 mb-3 filter-box">
            <input
              type="text"
              className="form-control custom-select"
              placeholder="Search ID, Customer, Serv..."
            />
            <select className="form-select custom-select">
              <option>Filter by Partner Name...</option>
              <option>Today</option>
              <option>Last Week</option>
              <option>Last Month</option>
              <option>Custom Date/Range</option>
            </select>
            <select className="form-select custom-select">
              <option>Filter by Status</option>
              <option>Online Sales</option>
              <option>Counter Sales</option>
            </select>
          </div>

          <TableWrapper>
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Request ID</th>
                  <th>Booking ID</th>
                  <th>Partner Type</th>
                  <th>Partner</th>
                  <th>Customer</th>
                  <th>Reason</th>
                  <th>Requested Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>R001</strong></td>
                  <td>B005</td>
                  <td><span className="badge badge-merchant">Merchant</span></td>
                  <td>Gourmet Bites Cafe</td>
                  <td>
                    Edward Scissorhands
                    <br />
                    <small className="text-muted">555-0105</small>
                  </td>
                  <td>Accidental booking</td>
                  <td>Jul 13, 2024, 3:30 PM</td>
                  <td>0.00 USD</td>
                  <td><span className="badge badge-approved">Approved</span></td>
                  <td className="text-center"><BsThreeDotsVertical /></td>
                </tr>
                <tr>
                  <td><strong>R002</strong></td>
                  <td>B001</td>
                  <td><span className="badge badge-org">Organization</span></td>
                  <td>City Heritage Tours</td>
                  <td>
                    Alice Wonderland
                    <br />
                    <small className="text-muted">555-0101</small>
                  </td>
                  <td>Changed plans</td>
                  <td>Jul 16, 2024, 5:00 PM</td>
                  <td>45.00 USD</td>
                  <td><span className="badge badge-requested">Requested</span></td>
                  <td className="text-center"><BsThreeDotsVertical /></td>
                </tr>
                <tr>
                  <td><strong>R003</strong></td>
                  <td>B004</td>
                  <td><span className="badge badge-business">Business</span></td>
                  <td>Aqua Fun Waterpark</td>
                  <td>
                    Diana Prince
                    <br />
                    <small className="text-muted">555-0104</small>
                  </td>
                  <td>Service not as expected</td>
                  <td>Jul 19, 2024, 8:30 PM</td>
                  <td>55.00 USD</td>
                  <td><span className="badge badge-rejected">Rejected</span></td>
                  <td className="text-center"><BsThreeDotsVertical /></td>
                </tr>
                <tr>
                  <td><strong>R004</strong></td>
                  <td>B002</td>
                  <td><span className="badge badge-business">Business</span></td>
                  <td>ThrillSeeker Adventures</td>
                  <td>
                    Bob The Builder
                    <br />
                    <small className="text-muted">555-0102</small>
                  </td>
                  <td>Weather cancellation</td>
                  <td>Jul 21, 2024, 2:30 PM</td>
                  <td>75.50 USD</td>
                  <td><span className="badge badge-processing">Processing</span></td>
                  <td className="text-center"><BsThreeDotsVertical /></td>
                </tr>
              </tbody>
            </table>
          </TableWrapper>
        </div>
      </div>
    </Wrapper>
  );
};

export default RefundsSuper;

const Wrapper = styled.div`
  .filter-box input,
  .filter-box select {
    width: 169px !important;
  }
    select.form-select.custom-select {
        width: 263px !important;
    }

    input.form-control.custom-select {
        width: 243px !important;
    }

`;

const TableWrapper = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }

  th,
  td {
    padding: 10px 12px;
    border: 1px solid #dee2e6;
    text-align: center;
    vertical-align: middle;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
  }

  .badge {
    display: inline-block;
    padding: 6px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 500;
  }

  .bg-purple {
    background-color: rgba(155, 89, 182, 0.15);
    color: #9b59b6;
  }

  .text-center {
    text-align: center;
  }
     .badge {
    font-size: 0.75rem;
    font-weight: 500;
    border-radius: 12px;
    padding: 4px 10px;
    display: inline-block;
  }

  .badge-merchant {
    background-color: rgba(255, 193, 7, 0.2);
    color: #ffc107;
  }

  .badge-org {
    background-color: rgba(13, 202, 240, 0.15);
    color: #0dcaf0;
  }

  .badge-business {
    background-color: rgba(0, 123, 255, 0.1);
    color: #0d6efd;
  }

  .badge-approved {
    background-color: rgba(25, 135, 84, 0.15);
    color: #198754;
  }

  .badge-requested {
    background-color: rgba(255, 193, 7, 0.15);
    color: #ffc107;
  }

  .badge-rejected {
    background-color: rgba(220, 53, 69, 0.15);
    color: #dc3545;
  }

  .badge-processing {
    background-color: rgba(13, 202, 240, 0.2);
    color: #0dcaf0;
  }

  .text-center {
    text-align: center;
  }
`;
